import './ConnectionLostModal.scss';
import { useTranslation } from '../../platform/stores';
import wifiAnimation from '../../assets/icons/wifi-animation.svg';

export const showConnectionLostModal = () => {
  const el = document.getElementById('connectionLostModal')
  if (el) {
    el.style.display = 'flex';
  }
};

export const hideConnectionLostModal = () => {
  const el = document.getElementById('connectionLostModal');
  if (el) {
    el.style.display = 'none';
  }
};

export const ConnectionLostModal = () => {
  const t = useTranslation();
  return (
    <div id="connectionLostModal">
      <div className="content">
        <img src={wifiAnimation} alt="WiFi"/>
        <div className="text">
          {t('CONNECTION_LOST')}
        </div>
      </div>
    </div>
  );
}
